type TLocalStorageKey = 'asr' | 'tts' | 'user'

export const getLocalStorageInfo = (key: TLocalStorageKey) => {
  return JSON.parse(localStorage.getItem(key) as string)
}

export const setLocalStorageInfo = (key: TLocalStorageKey, value: any) => {
  localStorage.setItem(key, JSON.stringify(value))
}
